module.exports = __webpack_public_path__ + "media/customizations/trinityfalls/back-10639d275c97bebf4a0b90e48196c8ba.jpg";